export enum ConfigOption {
  OPTIONAL = 'O',
  MANDATORY = 'M',
  PROHIBITED = 'P',
}

export interface IEditableFieldConfigResponse {
  mandatoryFields: Array<string>;
  optionalFields: Array<string>;
}

export interface IAccessControl {
  add: boolean;
  delete: boolean;
  modify: boolean;
}

export interface ISubDocs {
  attachedDocuments: IAccessControl;
  beneficiaries: IAccessControl;
  fees: IAccessControl;
  items: IAccessControl;
  packages: IAccessControl;
  treatments: IAccessControl;
}

export interface IConfig {
  operations: Record<string, IEditableFieldConfigResponse>;
  subDocs: ISubDocs;
}

export type Description =
  | 'lpco'
  | 'item'
  | 'beneficiaries'
  | 'request-fees'
  | 'fees'
  | 'attachedDocuments'
  | 'additionalfields'
  | 'request-additionalfields'
  | 'packages'
  | 'treatments';

export enum ConstraintType {
  size = 'size',
  pattern = 'pattern',
  email = 'email',
  positive = 'positive',
  positiveOrZero = 'positiveOrZero',
  pastOrPresent = 'pastOrPresent',
  notNull = 'notNull',
  notBlank = 'notBlank',
}

export interface IConstraintParams {
  regexp: 'string'; //with type pattern
  min: string; // with type size
  max: string; // with type size
  payload: null;
  groups: null;
  message: string;
}

export interface IConstraint {
  type: ConstraintType;
  params: IConstraintParams;
}

export interface IValidationConfigResponse {
  rules: Array<{
    description: Description;
    fields: Record<
      string,
      {
        visible: boolean;
        constraints: Array<IConstraint>;
      }
    >;
  }>;
}

export type TValidationConfig = Record<string, Record<ConstraintType, IConstraintParams>>;
